module.exports = __webpack_public_path__ + "static/media/target.1811e536.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/target.svg
// module id = 601
// module chunks = 0